import { render, staticRenderFns } from "./CollectionDetail.vue?vue&type=template&id=5d4a53fd&scoped=true&"
import script from "./CollectionDetail.vue?vue&type=script&lang=ts&"
export * from "./CollectionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionDetail.vue?vue&type=style&index=0&id=5d4a53fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4a53fd",
  null
  
)

export default component.exports